import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { debounce } from 'debounce';
import { getOptions } from '../../utils';

class NameInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = { ...props }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps && (prevState.modifiedDate !== nextProps.modifiedDate))
            return { ...nextProps };

        return null;
    }
    firstNameIsValid = () => this.state.firstName && this.state.firstName.length > 0;
    lastNameIsValid = () => this.state.lastName && this.state.lastName.length > 0;

    handleOnChange = (event) => {
        const { target: { name, value } } = event
        this.setState({ [name]: value }, this.throttleChanges);
    };

    throttleChanges = debounce(() => {
        const name = (({ generations, properTitles, onChange, ...others }) => ({ ...others }))(this.state);
        this.firstNameIsValid() && this.lastNameIsValid() && this.props.onChange(name)
    }, 1000);

    render() {
        return (
            <Row>
                <Col xs='2'>
                    <FormGroup>
                        <Label>Title:</Label>
                        <Input name='properTitle' type='select' id='selectProperTitle' onChange={this.handleOnChange} value={this.state.properTitle || ''}>
                            {getOptions(this.props.properTitles)}
                        </Input>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label>*First Name:</Label>
                        <Input
                            name='firstName'
                            invalid={!this.firstNameIsValid()}
                            type='text'
                            onChange={this.handleOnChange} value={this.state.firstName || ''} />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label>Middle Name:</Label>
                        <Input
                            name='middleName'
                            type='text'
                            onChange={this.handleOnChange}
                            value={this.state.middleName || ''} />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label>*Last Name:</Label>
                        <Input
                            name='lastName' type='text'
                            invalid={!this.lastNameIsValid()}
                            onChange={this.handleOnChange}
                            value={this.state.lastName || ''} />
                    </FormGroup>
                </Col>
                <Col xs='2'>
                    <FormGroup>
                        <Label>Generation:</Label>
                        <Input name='generation' type='select' id='selectGeneration' onChange={this.handleOnChange} value={this.state.generation || ''}>
                            {getOptions(this.props.generations)}
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
        );
    }
}

export default NameInput;